import React from "react";

const InvoiceTemplate = ({admin, other}) => {

  const formatUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        border: "1px solid #ccc",
      }}
    >
      <table
        width="100%"
        cellPadding="5"
        cellSpacing="0"
        border="0"
        style={{ fontFamily: "Arial, sans-serif", fontSize: "14px" }}
      >
        <tbody>
          <tr>
            <td width="50%" valign="top">
              <img
                src={admin?.invoice_blob}
                alt="Logo"
                height="50"
              />
            </td>
            <td width="25%" align="left" valign="top">
              <strong>{admin?.company_name}</strong>
              <br />
              <strong>Address:</strong> {admin?.company_address}
              <br />
              <strong>Email:</strong>{" "}
              <a href={`mailto:${admin?.admin_email}`}>{admin?.admin_email}</a>
              <br />
              <strong>Phone:</strong> {admin?.company_contact}
              <br />
              <strong>Website:</strong>{" "}
              <a href={formatUrl(admin?.website)} target="_blank" rel="noreferrer">
                {admin?.website}
              </a>
            </td>
          </tr>

          <tr>
            <td colSpan="2">
              <hr />
            </td>
          </tr>

          <tr>
            <td valign="top">
              <strong>Bill To:</strong>
              <br />
              {other?.company_name}
              <br />
              <strong>Address:</strong> {other?.company_address}
              <br />
              <strong>Phone:</strong> {other?.company_contact}
              <br />
              <strong>Email:</strong>{" "}
              <a href={`mailto:${other?.company_email}`}>
                {other?.company_email}
              </a>
            </td>
            <td align="left" valign="top">
              <strong>Invoice No:</strong>
              <br />{other?.invoice_number} <br/>
              <strong>Date:</strong> {other?.invoice_date}
              <br />
              <strong>Due Date:</strong> {other?.invoice_due_date}
              <br />
              <strong>Currency:</strong> {admin?.Currency}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Items Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f5f5f5" }}>
            <th style={thTdStyle}>S.No</th>
            <th style={thTdStyle}>Description</th>
            <th style={thTdStyle}>Details</th>
            <th style={thTdStyle}>Qty</th>
            <th style={thTdStyle}>Unit Price</th>
            <th style={thTdStyle}>Amount</th>
          </tr>
        </thead>
        <tbody>

          <tr dangerouslySetInnerHTML={{ __html: other?.tr_table_overview }} />

          <tr>
            <td colSpan="5" style={{ ...thTdStyle, textAlign: "right" }}>
              <strong>Subtotal</strong>
            </td>
            <td style={{ ...thTdStyle, textAlign: "right" }}>{other?.Subtotal}</td>
          </tr>
          <tr>
            <td colSpan="5" style={{ ...thTdStyle, textAlign: "right" }}>
              <strong>Total Amount Due:</strong>
            </td>
            <td style={{ ...thTdStyle, textAlign: "right" }}>
              <strong>{other?.total_amount}</strong>
            </td>
          </tr>
        </tbody>
      </table>

      <p style={{ marginTop: "10px", fontSize: "14px" }}>
        <strong>Amount in Words:</strong> {other?.amount_in_word}
      </p>

      <div dangerouslySetInnerHTML={{ __html: admin?.other_details }} />


    </div>
  );
};

const thTdStyle = {
  border: "1px solid #ccc",
  padding: "8px",
};

export default InvoiceTemplate;
